module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "menu-interno"
    }
  }, [_c('li', {}, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mudarSelecao('ccd-home')
      }
    }
  }, [_vm._v("Inicial")])]), _vm._v(" "), _c('li', {}, [_vm._v("Repositórios:")]), _vm._v(" "), _vm._l((_vm.acs), function(item, ref) {
    return _c('li', {
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.mudarAC(item._key)
        }
      }
    }, [_vm._v("AC " + _vm._s(item.nome))])])
  }), _vm._v(" "), _vm._l((_vm.pscs), function(item, ref) {
    return _c('li', {
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.mudarPSC(item._key)
        }
      }
    }, [_vm._v("PSC " + _vm._s(item.nome))])])
  }), _vm._v(" "), _c('li', {}, [_vm._v("Informações e Serviços:")]), _vm._v(" "), _vm._l((_vm.menu), function(item, ref) {
    return _c('li', {}, [_vm._v("  "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.mudarSelecao(ref)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dfa76fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 104
// module chunks = 0